import script from "./AppDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDesktop.vue?vue&type=script&setup=true&lang=ts"

import "./AppDesktop.vue?vue&type=style&index=0&id=32de48e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32de48e2"]])

export default __exports__